<template>
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 1080 1920"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    xml:space="preserve"
    xmlns:serif="http://www.serif.com/"
    style="fill-rule: evenodd; clip-rule: evenodd; stroke-miterlimit: 10"
  >
    <g id="Countdown">
      <g transform="matrix(0.5,0,0,0.5,982.998,101.5)">
        <path
          d="M0,373L-612.332,373C-656.227,373 -691.81,337.417 -691.81,293.522L-691.81,79.478C-691.81,35.583 -656.227,0 -612.332,0L0,0C43.894,0 79.478,35.583 79.478,79.478L79.478,293.522C79.478,337.417 43.894,373 0,373Z"
          style="
            fill: none;
            fill-rule: nonzero;
            stroke: rgb(203, 46, 190);
            stroke-width: 10px;
          "
        />
      </g>
      <g transform="matrix(1,0,0,1,-610.581,53.2564)">
        <g transform="matrix(116.5,0,0,116.5,1597.19,179.24)"></g>
        <text
          x="1283.8px"
          y="179.24px"
          style="
            font-family: 'CircularXX-Book', 'CircularXX', sans-serif;
            font-weight: 450;
            font-size: 116.5px;
            fill: rgb(203, 46, 190);
          "
        >
          00:{{ timeLeftFormatted }}
        </text>
      </g>
    </g>
    <g id="Points">
      <g transform="matrix(0.5,0,0,0.5,574.34,98.5)">
        <path
          d="M0,384L-612.332,384C-656.227,384 -691.81,348.417 -691.81,304.522L-691.81,79.478C-691.81,35.583 -656.227,0 -612.332,0L0,0C43.894,0 79.478,35.583 79.478,79.478L79.478,304.522C79.478,348.417 43.894,384 0,384Z"
          style="
            fill: rgb(129, 12, 144);
            fill-rule: nonzero;
            stroke: rgb(255, 236, 251);
            stroke-width: 0.25px;
          "
        />
      </g>
      <g transform="matrix(1,0,0,1,-259.092,306.663)">
        <g transform="matrix(116.5,0,0,116.5,716.464,-74.4175)"></g>
        <text
          x="680px"
          y="-74.417px"
          text-anchor="middle"
          style="
            font-family: 'CircularXX-Book', 'CircularXX', sans-serif;
            font-weight: 450;
            font-size: 116.5px;
            fill: white;
          "
        >
          {{ score }}
        </text>
      </g>
    </g>
    <g id="Battery">
      <g transform="matrix(0.5,0,0,0.5,176,60.204)">
        <path
          d="M0,83.592L0,26.897C0,12.042 12.042,0 26.897,0L218.668,0C233.523,0 245.565,12.042 245.565,26.897L245.565,76.592"
          style="
            fill: none;
            fill-rule: nonzero;
            stroke: rgb(255, 211, 252);
            stroke-width: 34px;
          "
        />
      </g>
      <g transform="matrix(0,-0.480887,-0.5,0,135.02,51)">
        <path
          d="M-106.054,106.054L106.054,106.054"
          style="
            fill: none;
            fill-rule: nonzero;
            stroke: rgb(255, 211, 252);
            stroke-width: 34.66px;
          "
        />
      </g>
      <g transform="matrix(0.5,0,0,0.5,204.851,287.178)">
        <path
          d="M0,-373.355L0,-80.584C0,-36.079 -36.079,0 -80.584,0L-224.118,0C-268.623,0 -304.702,-36.079 -304.702,-80.584L-304.702,-373.355L0,-373.355Z"
          style="
            fill: none;
            fill-rule: nonzero;
            stroke: rgb(83, 68, 63);
            stroke-width: 10px;
          "
        />
      </g>
      <g transform="matrix(0.5,0,0,0.5,204.851,261.178)">
        <path
          d="M0,-159.355L0,-27.584C0,16.921 -36.079,53 -80.584,53L-224.118,53C-268.623,53 -304.702,16.921 -304.702,-27.584L-304.702,-159.355C-304.702,-159.355 -230,-212.355 -152.351,-159.355C-74.702,-106.355 0,-159.355 0,-159.355Z"
          style="
            fill: rgb(129, 12, 144);
            fill-rule: nonzero;
            stroke: rgb(83, 68, 63);
            stroke-width: 10px;
          "
        />
      </g>
      <g transform="matrix(0,-0.5,-0.5,0,88.5,186.5)">
        <path
          d="M-29,-29C-45.016,-29 -58,-16.016 -58,0C-58,16.016 -45.016,29 -29,29C-12.984,29 0,16.016 0,0C0,-16.016 -12.984,-29 -29,-29"
          style="fill: rgb(255, 236, 251); fill-rule: nonzero"
        />
      </g>
      <g transform="matrix(0,-0.5,-0.5,0,149.5,215.5)">
        <path
          d="M-21,-21C-32.598,-21 -42,-11.598 -42,0C-42,11.598 -32.598,21 -21,21C-9.402,21 0,11.598 0,0C0,-11.598 -9.402,-21 -21,-21"
          style="fill: rgb(255, 236, 251); fill-rule: nonzero"
        />
      </g>
      <g transform="matrix(0,-0.5,-0.5,0,117.5,249.5)">
        <path
          d="M-15,-15C-23.284,-15 -30,-8.284 -30,0C-30,8.284 -23.284,15 -15,15C-6.716,15 0,8.284 0,0C0,-8.284 -6.716,-15 -15,-15"
          style="fill: rgb(255, 236, 251); fill-rule: nonzero"
        />
      </g>
      <g transform="matrix(0,-0.5,-0.5,0,180.5,244)">
        <path
          d="M-7,-7C-10.866,-7 -14,-3.866 -14,0C-14,3.866 -10.866,7 -7,7C-3.134,7 0,3.866 0,0C0,-3.866 -3.134,-7 -7,-7"
          style="fill: rgb(255, 236, 251); fill-rule: nonzero"
        />
      </g>
      <g transform="matrix(-0.5,0,0,0.5,257,-1734.5)">
        <rect
          x="225"
          y="3636"
          width="64"
          height="37"
          style="fill: rgb(83, 68, 63)"
        />
      </g>
      <g transform="matrix(-0.5,0,0,0.5,257,-1769)">
        <rect
          x="206"
          y="3673"
          width="102"
          height="32"
          style="fill: rgb(83, 68, 63)"
        />
      </g>
      <g transform="matrix(-0.5,0,0,0.5,162,-1725.5)">
        <rect
          x="130"
          y="3636"
          width="64"
          height="19"
          style="fill: rgb(83, 68, 63)"
        />
      </g>
      <g transform="matrix(0.5,0,0,0.5,192,102)">
        <rect
          x="-64"
          y="-37"
          width="64"
          height="37"
          style="fill: rgb(83, 68, 63); fill-rule: nonzero"
        />
      </g>
    </g>
    <g id="Fields" transform="matrix(0.5,0,0,0.5,-1.25,9.344)">
      <g transform="matrix(-0.98485,0,0,0.983607,536.064,-2012.48)">
        <rect
          x="105.138"
          y="2738.69"
          width="304.615"
          height="427"
          style="fill: white"
        />
      </g>
      <g transform="matrix(-0.98485,0,0,0.983607,856.056,-2012.48)">
        <rect
          x="105.138"
          y="2738.69"
          width="304.615"
          height="427"
          style="fill: white"
        />
      </g>
      <g transform="matrix(-0.98485,0,0,0.983607,1176.05,-2012.48)">
        <rect
          x="105.138"
          y="2738.69"
          width="304.615"
          height="427"
          style="fill: white"
        />
      </g>
      <g transform="matrix(-0.98485,0,0,0.983607,1496.04,-2012.48)">
        <rect
          x="105.138"
          y="2738.69"
          width="304.615"
          height="427"
          style="fill: white"
        />
      </g>
      <g transform="matrix(-0.98485,0,0,0.983607,1816.03,-2012.48)">
        <rect
          x="105.138"
          y="2738.69"
          width="304.615"
          height="427"
          style="fill: white"
        />
      </g>
      <g transform="matrix(-0.98485,0,0,0.983607,2136.03,-2012.48)">
        <rect
          x="105.138"
          y="2738.69"
          width="304.615"
          height="427"
          style="fill: white"
        />
      </g>
      <g transform="matrix(-0.98485,0,0,0.983607,536.064,-1572.39)">
        <rect
          x="105.138"
          y="2738.69"
          width="304.615"
          height="427"
          style="fill: white"
        />
      </g>
      <g transform="matrix(-0.98485,0,0,0.983607,856.056,-1572.39)">
        <rect
          x="105.138"
          y="2738.69"
          width="304.615"
          height="427"
          style="fill: white"
        />
      </g>
      <g transform="matrix(-0.98485,0,0,0.983607,1176.05,-1572.39)">
        <rect
          x="105.138"
          y="2738.69"
          width="304.615"
          height="427"
          style="fill: white"
        />
      </g>
      <g transform="matrix(-0.98485,0,0,0.983607,1496.04,-1572.39)">
        <rect
          x="105.138"
          y="2738.69"
          width="304.615"
          height="427"
          style="fill: white"
        />
      </g>
      <g transform="matrix(-0.98485,0,0,0.983607,1816.03,-1572.39)">
        <rect
          x="105.138"
          y="2738.69"
          width="304.615"
          height="427"
          style="fill: white"
        />
      </g>
      <g transform="matrix(-0.98485,0,0,0.983607,2136.03,-1572.39)">
        <rect
          x="105.138"
          y="2738.69"
          width="304.615"
          height="427"
          style="fill: white"
        />
      </g>
      <g transform="matrix(-0.98485,0,0,0.983607,536.064,-1132.48)">
        <rect
          x="105.138"
          y="2738.69"
          width="304.615"
          height="427"
          style="fill: white"
        />
      </g>
      <g transform="matrix(-0.98485,0,0,0.983607,856.056,-1132.48)">
        <rect
          x="105.138"
          y="2738.69"
          width="304.615"
          height="427"
          style="fill: white"
        />
      </g>
      <g transform="matrix(-0.98485,0,0,0.983607,1176.05,-1132.48)">
        <rect
          x="105.138"
          y="2738.69"
          width="304.615"
          height="427"
          style="fill: white"
        />
      </g>
      <g transform="matrix(-0.98485,0,0,0.983607,1496.04,-1132.48)">
        <rect
          x="105.138"
          y="2738.69"
          width="304.615"
          height="427"
          style="fill: white"
        />
      </g>
      <g transform="matrix(-0.98485,0,0,0.983607,1816.03,-1132.48)">
        <rect
          x="105.138"
          y="2738.69"
          width="304.615"
          height="427"
          style="fill: white"
        />
      </g>
      <g transform="matrix(-0.98485,0,0,0.983607,2136.03,-1132.48)">
        <rect
          x="105.138"
          y="2738.69"
          width="304.615"
          height="427"
          style="fill: white"
        />
      </g>
      <g transform="matrix(-0.98485,0,0,0.983607,536.064,-692.391)">
        <rect
          x="105.138"
          y="2738.69"
          width="304.615"
          height="427"
          style="fill: white"
        />
      </g>
      <g transform="matrix(-0.98485,0,0,0.983607,856.056,-692.391)">
        <rect
          x="105.138"
          y="2738.69"
          width="304.615"
          height="427"
          style="fill: white"
        />
      </g>
      <g transform="matrix(-0.98485,0,0,0.983607,1176.05,-692.391)">
        <rect
          x="105.138"
          y="2738.69"
          width="304.615"
          height="427"
          style="fill: white"
        />
      </g>
      <g transform="matrix(-0.98485,0,0,0.983607,1496.04,-692.391)">
        <rect
          x="105.138"
          y="2738.69"
          width="304.615"
          height="427"
          style="fill: white"
        />
      </g>
      <g transform="matrix(-0.98485,0,0,0.983607,1816.03,-692.391)">
        <rect
          x="105.138"
          y="2738.69"
          width="304.615"
          height="427"
          style="fill: white"
        />
      </g>
      <g transform="matrix(-0.98485,0,0,0.983607,2136.03,-692.391)">
        <rect
          x="105.138"
          y="2738.69"
          width="304.615"
          height="427"
          style="fill: white"
        />
      </g>
      <g transform="matrix(-0.98485,0,0,0.983607,536.064,-252.479)">
        <rect
          x="105.138"
          y="2738.69"
          width="304.615"
          height="427"
          style="fill: white"
        />
      </g>
      <g transform="matrix(-0.98485,0,0,0.983607,856.056,-252.479)">
        <rect
          x="105.138"
          y="2738.69"
          width="304.615"
          height="427"
          style="fill: white"
        />
      </g>
      <g transform="matrix(-0.98485,0,0,0.983607,1176.05,-252.479)">
        <rect
          x="105.138"
          y="2738.69"
          width="304.615"
          height="427"
          style="fill: white"
        />
      </g>
      <g transform="matrix(-0.98485,0,0,0.983607,1496.04,-252.479)">
        <rect
          x="105.138"
          y="2738.69"
          width="304.615"
          height="427"
          style="fill: white"
        />
      </g>
      <g transform="matrix(-0.98485,0,0,0.983607,1816.03,-252.479)">
        <rect
          x="105.138"
          y="2738.69"
          width="304.615"
          height="427"
          style="fill: white"
        />
      </g>
      <g transform="matrix(-0.98485,0,0,0.983607,2136.03,-252.479)">
        <rect
          x="105.138"
          y="2738.69"
          width="304.615"
          height="427"
          style="fill: white"
        />
      </g>
      <g transform="matrix(-0.98485,0,0,0.983607,536.064,187.609)">
        <rect
          x="105.138"
          y="2738.69"
          width="304.615"
          height="427"
          style="fill: white"
        />
      </g>
      <g transform="matrix(-0.98485,0,0,0.983607,856.056,187.609)">
        <rect
          x="105.138"
          y="2738.69"
          width="304.615"
          height="427"
          style="fill: white"
        />
      </g>
      <g transform="matrix(-0.98485,0,0,0.983607,1176.05,187.609)">
        <rect
          x="105.138"
          y="2738.69"
          width="304.615"
          height="427"
          style="fill: white"
        />
      </g>
      <g transform="matrix(-0.98485,0,0,0.983607,1496.04,187.609)">
        <rect
          x="105.138"
          y="2738.69"
          width="304.615"
          height="427"
          style="fill: white"
        />
      </g>
      <g transform="matrix(-0.98485,0,0,0.983607,1816.03,187.609)">
        <rect
          x="105.138"
          y="2738.69"
          width="304.615"
          height="427"
          style="fill: white"
        />
      </g>
      <g transform="matrix(-0.98485,0,0,0.983607,2136.03,187.609)">
        <rect
          x="105.138"
          y="2738.69"
          width="304.615"
          height="427"
          style="fill: white"
        />
      </g>
    </g>
    <g :transform="negFieldTransform()">
      <g
        id="negField"
        transform="matrix(0.118182,0,0,0.118033,75.1817,341.69)"
        v-if="gameActive"
        @click="negFieldClicked"
      >
        <g transform="matrix(-4.16667,0,0,4.16667,7040.64,-3874.12)">
          <rect
            x="1407.85"
            y="946.688"
            width="304.615"
            height="427"
            style="fill: rgb(246, 84, 220)"
          />
        </g>
        <g transform="matrix(4.16667,0,0,4.16667,334.223,1210.55)">
          <path
            d="M0,-120.708L0,-140.826L0,-120.708ZM50.295,20.118C58.678,20.118 65.803,17.184 71.671,11.317C77.538,5.449 80.472,-1.676 80.472,-10.059L50.295,-10.059L50.295,-30.177L80.472,-30.177L80.472,-50.295L50.295,-50.295L50.295,-70.413L80.472,-70.413L80.472,-100.59L20.118,-100.59L20.118,-10.059C20.118,-1.676 23.052,5.449 28.92,11.317C34.787,17.184 41.913,20.118 50.295,20.118M0,-120.708L100.59,-120.708L100.59,-140.826L0,-140.826L0,-120.708ZM50.295,40.236C36.38,40.236 24.519,35.332 14.711,25.525C4.904,15.717 0,3.856 0,-10.059L0,-100.59C-5.532,-100.59 -10.269,-102.56 -14.208,-106.5C-18.148,-110.439 -20.118,-115.176 -20.118,-120.708L-20.118,-140.826C-20.118,-146.359 -18.148,-151.095 -14.208,-155.034C-10.269,-158.974 -5.532,-160.944 0,-160.944L100.59,-160.944C106.123,-160.944 110.859,-158.974 114.798,-155.034C118.738,-151.095 120.708,-146.359 120.708,-140.826L120.708,-120.708C120.708,-115.176 118.738,-110.439 114.798,-106.5C110.859,-102.56 106.123,-100.59 100.59,-100.59L100.59,-10.059C100.59,3.856 95.686,15.717 85.879,25.525C76.071,35.332 64.21,40.236 50.295,40.236"
            style="fill: white; fill-rule: nonzero"
          />
        </g>
      </g>
    </g>
    <g :transform="posFieldTransform()">
      <g
        id="posFIeld"
        transform="matrix(1.12636,0,0,1.12494,-19.3504,-49.8003)"
        v-if="gameActive"
        @click="posFieldClicked"
      >
        <g transform="matrix(-0.437184,0,0,0.437184,538.888,-646.052)">
          <rect
            x="758.754"
            y="2290.69"
            width="304.615"
            height="427"
            style="fill: rgb(81, 0, 102)"
          />
        </g>
        <g transform="matrix(0.437184,0,0,0.437184,136.482,463.06)">
          <path
            d="M0,-67.962C3.851,-67.962 7.079,-69.265 9.685,-71.87C12.29,-74.475 13.593,-77.703 13.593,-81.555C13.593,-85.406 12.29,-88.634 9.685,-91.239C7.079,-93.845 3.851,-95.147 0,-95.147C-3.851,-95.147 -7.079,-93.845 -9.685,-91.239C-12.29,-88.634 -13.593,-85.406 -13.593,-81.555C-13.593,-77.703 -12.29,-74.475 -9.685,-71.87C-7.079,-69.265 -3.851,-67.962 0,-67.962M42.816,-60.486L55.05,-65.243L31.942,-129.129L19.03,-124.371L42.816,-60.486ZM-74.759,95.148L-74.759,67.963L-6.796,67.963L-6.796,40.778C-25.599,40.778 -41.627,34.152 -54.88,20.899C-68.133,7.646 -74.759,-8.381 -74.759,-27.184C-74.759,-41.004 -70.964,-53.577 -63.375,-64.904C-55.786,-76.231 -45.535,-84.5 -32.622,-89.71C-30.81,-97.413 -26.789,-103.642 -20.559,-108.4C-14.329,-113.157 -7.249,-115.536 0.68,-115.536L-6.796,-136.604L6.117,-141.362L1.359,-153.595L27.185,-163.11L31.263,-150.197L44.176,-154.954L81.555,-53.01L68.642,-48.253L73.4,-35.34L47.574,-25.825L43.496,-38.738L30.583,-33.981L22.428,-56.409C19.03,-53.237 15.122,-50.858 10.704,-49.272C6.287,-47.687 1.812,-47.12 -2.719,-47.573C-7.702,-48.026 -12.347,-49.556 -16.651,-52.161C-20.955,-54.766 -24.693,-57.994 -27.865,-61.846C-33.981,-58.221 -38.795,-53.35 -42.307,-47.233C-45.818,-41.117 -47.574,-34.434 -47.574,-27.184C-47.574,-15.858 -43.609,-6.229 -35.68,1.7C-27.751,9.629 -18.123,13.593 -6.796,13.593L101.944,13.593L101.944,40.778L33.981,40.778L33.981,67.963L115.536,67.963L115.536,95.148L-74.759,95.148Z"
            style="fill: white; fill-rule: nonzero"
          />
        </g>
      </g>
    </g>
    <g
      id="StartModal"
      transform="matrix(0.5,0,0,0.5,0,2.84217e-14)"
      v-if="!gameActive"
    >
      <g transform="matrix(2.00743,0,0,2,-9756.13,5.68434e-14)">
        <rect
          x="4860"
          y="0"
          width="1076"
          height="1920"
          style="fill-opacity: 0.5"
        />
      </g>
      <g
        id="StartBtn"
        transform="matrix(1,0,0,1,1.81899e-11,-875.592)"
        @click="startGame()"
      >
        <g transform="matrix(1,0,0,1,1897.46,2536.77)">
          <path
            d="M0,258.817L-1625.92,258.817C-1678.13,258.817 -1720.46,216.489 -1720.46,164.275L-1720.46,94.542C-1720.46,42.328 -1678.13,0 -1625.92,0L0,0C52.214,0 94.542,42.328 94.542,94.542L94.542,164.275C94.542,216.489 52.214,258.817 0,258.817"
            style="fill: rgb(81, 0, 102); fill-rule: nonzero"
          />
        </g>
        <g transform="matrix(0.24,0,0,0.24,472.722,1990.19)">
          <g transform="matrix(538.065,0,0,538.065,3913.43,3008.23)"></g>
          <text
            x="1314.58px"
            y="3008.24px"
            style="
              font-family: 'CircularXX-Book', 'CircularXX', sans-serif;
              font-weight: 450;
              font-size: 538.065px;
              fill: white;
            "
          >
            S
            <tspan
              x="1621.81px 1803.14px 2079.16px 2269.1px 2450.43px 2580.64px 2888.95px 3164.98px 3619.11px "
              y="3008.24px 3008.24px 3008.24px 3008.24px 3008.24px 3008.24px 3008.24px 3008.24px 3008.24px "
            >
              tart game
            </tspan>
          </text>
        </g>
      </g>
    </g>
  </svg>
</template>

<script>
export default {
  name: "GameScreen",
  data() {
    return {
      gameTime: 20, // Total time for the game
      gameTimeLeft: 20, // Countdown time in seconds
      score: 0,
      posActiveField: 0,
      negActiveField: 0,
      isRunning: false, // Track if the timer is running
      timer: null, // Reference to the interval timer
      posFieldTimer: null, // Timer for the posField countdown
      posFieldTime: 100, // Countdown time for positive field in milliseconds
      gameActive: false,
      fieldsRange: 36,
      fieldArray: [
        { x: 0, y: 0 },
        { x: 160, y: 0 },
        { x: 320, y: 0 },
        { x: 480, y: 0 },
        { x: 640, y: 0 },
        { x: 800, y: 0 },
        { x: 0, y: 220 },
        { x: 160, y: 220 },
        { x: 320, y: 220 },
        { x: 480, y: 220 },
        { x: 640, y: 220 },
        { x: 800, y: 220 },
        { x: 0, y: 440 },
        { x: 160, y: 440 },
        { x: 320, y: 440 },
        { x: 480, y: 440 },
        { x: 640, y: 440 },
        { x: 800, y: 440 },
        { x: 0, y: 660 },
        { x: 160, y: 660 },
        { x: 320, y: 660 },
        { x: 480, y: 660 },
        { x: 640, y: 660 },
        { x: 800, y: 660 },
        { x: 0, y: 880 },
        { x: 160, y: 880 },
        { x: 320, y: 880 },
        { x: 480, y: 880 },
        { x: 640, y: 880 },
        { x: 800, y: 880 },
        { x: 0, y: 1100 },
        { x: 160, y: 1100 },
        { x: 320, y: 1100 },
        { x: 480, y: 1100 },
        { x: 640, y: 1100 },
        { x: 800, y: 1100 },
      ],
    };
  },
  created() {
    this.assignActiveFields();
  },
  computed: {
    timeLeftFormatted() {
      return this.gameTimeLeft.toString().padStart(2, "0");
    },
    batteryHeight() {
      const maxHeight = 0.223; // Maximum height at 100%
      return (this.score / 750) * maxHeight;
    },
    yPosition() {
      const maxHeight = 0.223;
      return -0.112 + (maxHeight - this.batteryHeight);
    },
  },
  methods: {
    startGame() {
      this.assignActiveFields();
      this.startTimer();
      this.gameActive = true;
    },
    posFieldClicked() {
      if (this.gameActive) {
        console.log(this.posFieldTime);
        this.score += Math.round(this.posFieldTime / 2); // Add remaining posFieldTime to score
        this.score += 2; // Base score for positive field click
        // this.score += this.posFieldTime;
        this.resetPosFieldTimer(); // Reset the positive field timer
        this.assignActiveFields();
      }
    },
    negFieldClicked() {
      if (this.gameActive) {
        this.score -= 1;
        this.assignActiveFields();
      }
    },
    negFieldTransform() {
      const { x, y } = this.fieldArray[this.negActiveField - 1];
      return `translate(${x * 1}, ${y * 1})`;
    },
    posFieldTransform() {
      const { x, y } = this.fieldArray[this.posActiveField - 1];
      return `translate(${x * 1}, ${y * 1})`;
    },
    assignActiveFields() {
      this.posActiveField = this.getRandomNumber(
        this.fieldsRange,
        this.posActiveField,
        this.negActiveField
      );

      this.negActiveField = this.getRandomNumber(
        this.fieldsRange,
        this.posActiveField,
        this.negActiveField
      );

      this.resetPosFieldTimer(); // Reset the timer whenever a new posField is assigned
    },
    getRandomNumber(range, ...exclusions) {
      let randomNum;
      do {
        randomNum = Math.floor(Math.random() * range) + 1;
      } while (exclusions.includes(randomNum));
      return randomNum;
    },
    resetPosFieldTimer() {
      clearInterval(this.posFieldTimer); // Clear the old timer
      this.posFieldTime = 200; // Reset to 100 milliseconds
      // console.log("Timer reset to:", this.posFieldTime); // Log reset time
      this.posFieldTimer = setInterval(() => {
        if (this.posFieldTime > 0) {
          this.posFieldTime--;
          // console.log("PosFieldTime:", this.posFieldTime); // Log countdown
        } else {
          clearInterval(this.posFieldTimer); // Stop when it reaches 0
        }
      }, 1);
    },
    startTimer() {
      if (this.isRunning) return;
      this.isRunning = true;
      this.timer = setInterval(() => {
        if (this.gameTimeLeft > 0) {
          this.gameTimeLeft--;
        } else {
          this.endTimer();
        }
      }, 1000);
    },
    endTimer() {
      clearInterval(this.timer);
      clearInterval(this.posFieldTimer); // Stop the posField timer
      this.isRunning = false;
      this.onTimerEnd();
    },
    resetTimer() {
      clearInterval(this.timer);
      clearInterval(this.posFieldTimer); // Clear the posField timer
      this.isRunning = false;
      this.gameTimeLeft = this.gameTime;
    },
    onTimerEnd() {
      this.gameActive = false;
      this.$store.commit("setScore", this.score);
      this.$store.dispatch("updatePlayer");
      this.$store.commit("setPlayerState", "end");
    },
  },
  beforeUnmount() {
    clearInterval(this.timer);
    clearInterval(this.posFieldTimer); // Clean up posField timer
  },
};
</script>

<style></style>
